import React from 'react';
import PropTypes from 'prop-types';
import Image from "next/legacy/image";

import ArrowOut from '../../../../shared/SVG/ArrowOut';
import styles from './SolutionCard.module.scss';

export default function SolutionCard({ body, header, image, link, title }) {
  return (
    <div className={styles.solutionCard}>
      <a href={link} className={styles.cardLink} target="_blank" rel="noreferrer">
        {title}
      </a>
      <div className={styles.productTitleWrap}>
        <h3 className={styles.productTitle}>{title}</h3>
        <ArrowOut />
      </div>
      <div className={styles.cardBodyWrap}>
        <div className={styles.imageWrapper}>
          <Image
            alt={title}
            src={image}
            className={styles.icon}
            layout="fixed"
            height={64}
            width={64}
          />
        </div>
        <div className={styles.copyWrapper}>
          <h3 className={styles.header}>{header}</h3>
          <p className={styles.body}>{body}</p>
        </div>
      </div>
    </div>
  );
}

SolutionCard.propTypes = {
  body: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  image: PropTypes.shape({}).isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
